import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import AppRequests from "components/ProjectSpecificComponents/API/AppRequests/AppRequests"
import { UserContext } from "components/ProjectSpecificComponents/Contexts/UserContext"
import React, { useContext, useEffect, useState } from "react"
import styled from "styled-components"

type TVersionNr = string

const Footer = () => {
	const year = new Date().getFullYear()
	const [versionNr, setVersionNr] = useState<TVersionNr>("")

	useEffect(() => {
		const getVersionNr = async () => {
			const { ok, data } = await AppRequests("VersionNumber").get<TVersionNr>()
			if (ok && data) {
				setVersionNr(data)
			}
		}
		getVersionNr()
	}, [])

	return (
		<div className="fixed bottom-0 w-screen">
			<div className="flex justify-between px-2">
				<FooterP>SIA "AA Projekts" © {year}</FooterP>
				<FooterP>VerNr: {versionNr}</FooterP>
			</div>
		</div>
	)
}

export default Footer

const FooterP = styled.p`
	color: "black";
	font-size: 12px;
	opacity: 0.3;
	:hover {
		opacity: 1;
	}
`
